<template>
    <li>
      <div class="panel panel-grey">
        <div class="panel-body">
          <div class="form-horizontal">
            <div class="row">
              <div class="checkbox checkbox-primary col-sm-9">
                <input
                  type="checkbox"
                  name="opportunities[]"
                  :value="{ id: childOpportunity.id }"
                  :id="`checkbox-opportunity-${opportunity.id}-${childOpportunity.id}`"
                  v-model="stateOpportunities">
                <label :for="`checkbox-opportunity-${opportunity.id}-${childOpportunity.id}`">
                  {{ childOpportunity.name }}
                </label>
              </div>
              <div class="col-sm-3" v-if="opportunitiesWithBudget.includes(childOpportunity.name.trim().toLowerCase())">
                <div :class="$hasErrorClass($v.stateOpportunityChildrenBudget, 'form-group')">
                  <input type="text" disabled placeholder="Budget" v-model="$v.stateOpportunityChildrenBudget.$model" class="form-control"/>
                  <vuelidate-help label="Budget" :field="$v.stateOpportunityChildrenBudget"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </li>
</template>

<script>

import { stateMapper } from 'mixins/users'
import {decimal} from 'vuelidate/lib/validators'
import VuelidateHelp from '../misc/VuelidateHelp'

export default {
  mixins: [stateMapper],
  props: {
    childOpportunity: {
      type: Object,
      required: true
    },
    opportunity: {
      type: Object,
      required: true
    },
    budgets: {
      required: false,
      type: Array
    },
    opportunitiesWithBudget: {
      required: true,
      type: Array
    }
  },
  mounted () {
    this.budgets && this.budgets.map(x => {
      if (this.childOpportunity.id === x.opportunity_id) {
        this.$v.stateOpportunityChildrenBudget.$model = x.budget
        // this.setChildBudget(x.opportunity_id)
      }
    })
  },
  data () {
    return {
      stateOpportunityChildrenBudget: null
    }
  },

  validations () {
    return {
      stateOpportunityChildrenBudget: {
        decimal
      }
    }
  },

  // methods: {
  //   setChildBudget (id) {
  //     this.$emit('input', {id, budget: this.$v.stateOpportunityChildrenBudget.$model})
  //   }
  // },
  components: {
    VuelidateHelp
  }
}
</script>

<style scoped>

</style>
